import { Badge } from '@/components/ui/badge';
import { Phone, Mail, Calendar } from 'lucide-react';

const LeadCard = ({ lead, onClick, style, showRevenue = false }) => {
  const statusColors = {
    new: 'status-new',
    interested: 'status-interested',
    not_interested: 'status-not-interested',
    callback: 'status-callback',
    contacted: 'status-contacted',
    qualified: 'status-qualified',
    won: 'status-won',
    lost: 'status-lost'
  };

  const sourceColors = {
    meta: 'bg-blue-100 text-blue-700',
    google: 'bg-red-100 text-red-700',
    website: 'bg-purple-100 text-purple-700',
    manual: 'bg-slate-100 text-slate-700'
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
  };

  return (
    <div 
      className="p-4 hover:bg-slate-50 cursor-pointer transition-colors animate-fade-in"
      onClick={onClick}
      style={style}
      data-testid={`lead-card-${lead.lead_id}`}
    >
      <div className="flex items-start gap-4">
        {/* Lead Info */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1.5">
            <h4 className="font-semibold text-slate-900 truncate">{lead.name}</h4>
            <Badge className={`${statusColors[lead.status] || 'status-new'} text-xs border`}>
              {lead.status?.replace('_', ' ')}
            </Badge>
          </div>
          
          <div className="flex flex-wrap items-center gap-3 text-sm text-slate-500">
            {lead.phone && (
              <span className="flex items-center gap-1.5">
                <Phone className="w-3.5 h-3.5" />
                {lead.phone}
              </span>
            )}
            {lead.email && (
              <span className="flex items-center gap-1.5 truncate">
                <Mail className="w-3.5 h-3.5" />
                <span className="truncate max-w-[150px]">{lead.email}</span>
              </span>
            )}
          </div>
          
          {lead.callback_date && (
            <div className="flex items-center gap-1.5 mt-2 text-xs text-amber-600">
              <Calendar className="w-3.5 h-3.5" />
              Callback: {formatDate(lead.callback_date)}
            </div>
          )}
        </div>

        {/* Right Side */}
        <div className="flex flex-col items-end gap-2">
          <Badge className={`${sourceColors[lead.source] || sourceColors.manual} text-xs`}>
            {lead.source}
          </Badge>
          {showRevenue && (
            <span className="text-sm font-medium text-slate-700">
              £{(lead.revenue || 0).toLocaleString()}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeadCard;
